/**
 * Crea las fichas que se utilizan para elegir el valor de apuesta
 * @param {*} scene
 */
export function crearFichasEleccion(scene) {
  scene.fichaSeleccionadaValor = 10;

  scene.fichaEleccion10 = scene.add
    .image(342, 442, 'ficha10Selected')
    .setInteractive();

  scene.fichaEleccion10.on('pointerover', () => {
    if (scene.fichaSeleccionadaValor !== 10) {
      scene.fichaEleccion10.setTexture('ficha10Hover');
    }
  });

  scene.fichaEleccion10.on('pointerout', () => {
    if (scene.fichaSeleccionadaValor !== 10) {
      scene.fichaEleccion10.setTexture('ficha10');
    }
  });

  scene.fichaEleccion10.on('pointerdown', () => {
    if (scene.fichaSeleccionadaValor !== 10) {
      scene.fichaEleccion10.setTexture('ficha10Selected');
      scene.fichaSeleccionadaValor = 10;
      scene.cambiarFichaSeleccionadaValor(10);

      scene.fichaEleccion20.setTexture('ficha20');
      scene.fichaEleccion50.setTexture('ficha50');
      scene.fichaEleccion100.setTexture('ficha100');
    }
  });

  /*/=======================================================================================\*\
  ||                                        FICHA 20                                         ||
  \*\=======================================================================================/*/

  scene.fichaEleccion20 = scene.add.image(245, 442, 'ficha20').setInteractive();

  scene.fichaEleccion20.on('pointerover', () => {
    if (scene.fichaSeleccionadaValor !== 20) {
      scene.fichaEleccion20.setTexture('ficha20Hover');
    }
  });

  scene.fichaEleccion20.on('pointerout', () => {
    if (scene.fichaSeleccionadaValor !== 20) {
      scene.fichaEleccion20.setTexture('ficha20');
    }
  });

  scene.fichaEleccion20.on('pointerdown', () => {
    if (scene.fichaSeleccionadaValor !== 20) {
      scene.fichaEleccion20.setTexture('ficha20Selected');
      scene.fichaSeleccionadaValor = 20;
      scene.cambiarFichaSeleccionadaValor(20);

      scene.fichaEleccion10.setTexture('ficha10');
      scene.fichaEleccion50.setTexture('ficha50');
      scene.fichaEleccion100.setTexture('ficha100');
    }
  });

  /*/=======================================================================================\*\
  ||                                        FICHA 50                                         ||
  \*\=======================================================================================/*/
  scene.fichaEleccion50 = scene.add.image(151, 442, 'ficha50').setInteractive();

  scene.fichaEleccion50.on('pointerover', () => {
    if (scene.fichaSeleccionadaValor !== 50) {
      scene.fichaEleccion50.setTexture('ficha50Hover');
    }
  });

  scene.fichaEleccion50.on('pointerout', () => {
    if (scene.fichaSeleccionadaValor !== 50) {
      scene.fichaEleccion50.setTexture('ficha50');
    }
  });

  scene.fichaEleccion50.on('pointerdown', () => {
    if (scene.fichaSeleccionadaValor !== 50) {
      scene.fichaEleccion50.setTexture('ficha50Selected');
      scene.fichaSeleccionadaValor = 50;
      scene.cambiarFichaSeleccionadaValor(50);

      scene.fichaEleccion10.setTexture('ficha10');
      scene.fichaEleccion20.setTexture('ficha20');
      scene.fichaEleccion100.setTexture('ficha100');
    }
  });

  /*/=======================================================================================\*\
  ||                                        FICHA 100                                        ||
  \*\=======================================================================================/*/
  scene.fichaEleccion100 = scene.add
    .image(54, 442, 'ficha100')
    .setInteractive();

  scene.fichaEleccion100.on('pointerover', () => {
    if (scene.fichaSeleccionadaValor !== 100) {
      scene.fichaEleccion100.setTexture('ficha100Hover');
    }
  });

  scene.fichaEleccion100.on('pointerout', () => {
    if (scene.fichaSeleccionadaValor !== 100) {
      scene.fichaEleccion100.setTexture('ficha100');
    }
  });

  scene.fichaEleccion100.on('pointerdown', () => {
    if (scene.fichaSeleccionadaValor !== 100) {
      scene.fichaEleccion100.setTexture('ficha100Selected');
      scene.fichaSeleccionadaValor = 100;
      scene.cambiarFichaSeleccionadaValor(100);

      scene.fichaEleccion10.setTexture('ficha10');
      scene.fichaEleccion20.setTexture('ficha20');
      scene.fichaEleccion50.setTexture('ficha50');
    }
  });
}
